import { ApolloProvider } from '@apollo/client';
import React from 'react';

import { Helmet } from 'react-helmet';
import { getApolloClient } from '../client';
import { SEO } from '../components/Seo';

import { SearchResults } from '../components/search-results-parts';
import { useSeoPropertyData } from '../hooks/useSeoPropertyData';

const TheSearchResult = (props) => {
  const { seoData, canonical } = useSeoPropertyData();
  const metaTitle = seoData?.title || 'KFH Property Search';
  return (
    <>
      <Helmet>
        <title id="kfh-seo-title">{metaTitle}</title>
        {canonical && <link rel="canonical" href={`https://www.kfh.co.uk${canonical}`} id="kfh-canonical" />}
      </Helmet>
      <SearchResults {...props} />
    </>
  );
};

export default TheSearchResult;

export const Head = () => {
  const { seoData, canonical } = useSeoPropertyData();
  return (
    <ApolloProvider client={getApolloClient()}>
      <SEO
        data={seoData || { title: 'KFH Property Search' }}
        canonical={canonical ? `https://www.kfh.co.uk${canonical}` : undefined}
      />
    </ApolloProvider>
  );
};
